/** Thermal label size for CSS @page / layout — adjust per Argox stock. */
export const LABEL_DIMENSIONS_MM = {
  widthMm: 100,
  heightMm: 150,
};
